import React from 'react';
import { useTranslation } from 'react-i18next';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  itemName,
  isLoading = false 
}) => {
  const { t } = useTranslation('organizers');

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div 
      className="organizers-delete-modal-overlay" 
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <div className="organizers-delete-modal-content" role="dialog" aria-modal="true">
        {/* Modal Header */}
        <div className="organizers-delete-modal-header">
          {/* <div className="organizers-delete-modal-icon">
            <img src="/alert-triangle.svg" alt={t('warning')} className="organizers-delete-warning-icon" />
          </div> */}
          <h3 className="organizers-delete-modal-title">
            {title || t('deleteConfirmationTitle')}
          </h3>
          <button
            onClick={onClose}
            className="organizers-delete-modal-close-btn"
            aria-label={t('close')}
            disabled={isLoading}
          >
            <img src="/x.svg" alt={t('close')} className="organizers-delete-close-icon" />
          </button>
        </div>

        {/* Modal Body */}
        <div className="organizers-delete-modal-body">
          <p className="organizers-delete-modal-message">
            {message || t('deleteConfirmationMessage')}
          </p>
          {itemName && (
            <div className="organizers-delete-item-highlight">
              <strong>{itemName}</strong>
            </div>
          )}
          <p className="organizers-delete-modal-warning">
            {t('deleteWarning')}
          </p>
        </div>

        {/* Modal Footer */}
        <div className="organizers-delete-modal-footer">
          <button
            onClick={onClose}
            className="organizers-delete-btn organizers-delete-btn-cancel"
            disabled={isLoading}
          >
            {t('cancel')}
          </button>
          <button
            onClick={onConfirm}
            className="organizers-delete-btn organizers-delete-btn-delete"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="organizers-delete-loading-content">
                <img src="/loader.svg" alt={t('loading')} className="organizers-delete-spinner" />
                {t('deleting')}
              </span>
            ) : (
              <>
                <img src="/trash.svg" alt={t('delete')} className="organizers-delete-icon" />
                {t('delete')}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;